import { useEffect, useState } from "react";

const KEY = "climnova_consent";
const SIX_MONTHS = 1000 * 60 * 60 * 24 * 182;
const EVENT = "climnova-consent-change";

export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    if (!c || Date.now() - new Date(c.at).getTime() > SIX_MONTHS) return null;
    return c;
  } catch {
    return null;
  }
};

export const saveConsent = (ads) => {
  const c = { necessary: true, ads: !!ads, at: new Date().toISOString(), version: 1 };
  localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new CustomEvent(EVENT, { detail: c }));
};

export const openCookiePanel = () => window.dispatchEvent(new CustomEvent("climnova-open-cookies"));

export const useConsent = () => {
  const [consent, setConsent] = useState(getConsent);
  useEffect(() => {
    const on = (e) => setConsent(e.detail);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return consent;
};

export const useAdsConsent = () => useConsent()?.ads === true;
